import { LookupManager } from '../components/LookupManager';
import { tr } from '../lib/i18n';

export function CategoriesPage() {
  return (
    <LookupManager
      path="property-categories"
      queryKey="property-categories"
      title={tr('فئات العقار', 'Property categories')}
      description={tr('الفئات الكبرى التي تُجمَّع تحتها أنواع العقار', 'The top-level groups property types belong to')}
      addLabel={tr('فئة جديدة', 'New category')}
    />
  );
}
